// Mirror config/catalog.php in the backend when introducing another root route.
export const RESERVED_CATALOG_SLUGS = new Set([
  'api', 'admin', 'app', 'assets', 'storage', 'public', 'build', 'css', 'js', 'img', 'images',
  'fonts', 'media', 'uploads', 'static', 'sanctum', 'oauth', 'auth', 'health', 'up',
  'dashboard', 'calendar', 'attendants-day', 'chat', 'whatsapp-campaigns', 'clients',
  'performance', 'sales', 'products', 'financial-management', 'configurations', 'configuration',
  'payment', 'payments', 'login', 'logout', 'register', 'forgot-password',
  'send-email-forgot-password', 'terms', 'privacy-policy', 'access-denied', 'onboarding',
  'checkout', 'reset', 'logs', 'recordings', 'catalog', 'catalogo', 'produto', 'www',
  'favicon-ico', 'robots-txt', 'sitemap-xml',
]);

export function isStorefrontPath(path: string): boolean {
  const match = path.match(/^\/([a-z0-9]+(?:-[a-z0-9]+)*)(?:\/(?:catalogo|produto\/\d+))?\/?$/);
  return Boolean(match && match[1].length >= 3 && match[1].length <= 60 && !RESERVED_CATALOG_SLUGS.has(match[1]));
}
